import { Navigate, useParams } from "react-router-dom"

export const RedirectToMaterial = () => {
    const { id, employeeId, visitId } = useParams();
    
    if (employeeId) {
        return <Navigate to={`/exam/material/${id}/employee/${employeeId}`} replace />;
    }
    
    if (visitId) {
        return <Navigate to={`/exam/material/${id}/visit/${visitId}`} replace />;
    }
    
    return <Navigate to={'/login'} replace />;
}

